import $ from 'jquery';

export class CookiesConsent {
  constructor() {
    const cookiesClosed = localStorage.getItem('hw-cookies-closed');

    if (cookiesClosed != 'true') $('#hw-cookies-consent').removeClass('d-none');

    $('#hw-cookies-btn-configure').on('click', (event) => {
      event.preventDefault();

      $('#hw-cookies-consent-introduction').addClass('d-none');
      $('#hw-cookies-consent-details').removeClass('d-none');
    });

    $('#hw-cookies-close, #hw-cookies-btn-agree, #hw-cookies-btn-close').on('click', (event) => {
      event.preventDefault();

      $('#hw-cookies-consent').addClass('d-none');

      localStorage.setItem('hw-cookies-closed', 'true');
    });
  }
}
